import { useInfiniteQuery } from '@tanstack/react-query';
import { INBOX_DEFAULT_PAGE_SIZE } from '../../defaults';
import { InboxFiltersOptions } from '../../types/InboxTypes';
import { requestNewRecent } from '../newRecent/newRecent';
import { InboxItemsResponse } from '../newRecent/types/InboxItemsResponse';

export function useNewRecent(filter: InboxFiltersOptions) {
    return useInfiniteQuery<InboxItemsResponse, Error>({
        queryKey: ['newAndRecent', filter],
        queryFn: async ({ signal, pageParam = 0 }) => {
            return await requestNewRecent(
                {
                    ...filter,
                    pageNumber: pageParam || 0,
                    pageSize: INBOX_DEFAULT_PAGE_SIZE,
                    lastItemDate: undefined, //todo
                },
                signal,
            );
        },
        getNextPageParam: (lastPage, pages) => {
            if (lastPage.pageNum < lastPage.totalPages - 1) {
                return lastPage.pageNum + 1;
            }
            return undefined;
        },
        refetchInterval: 15000,
    });
}
